import styled from 'styled-components';

export const StyledSimpleLayout = styled.div`
  height: 100%;
  width: 100%;
`;
